import vSelect from 'vue-select';
import { ValidationMessage, ValidatedInput, FormLabel } from "../../../shared/components";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isNewTaskPrompt: {
      type: Boolean,
      default: false
    },
    taskEntry: {
      type: Object,
      default: null
    },
    existingTasks: {
      type: Array,
      required: true,
      default: []
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    ValidatedInput,
    FormLabel
  },
  data () {
    return {
      model: this.createModel(),
      isPopupActive: this.$props.isActive,
      origOtherTaskName: '',
      isValid: false,
      isDuplicateEntry: false,
      unmodifiedEntry: null,
      showAllTasks: false
    };
  },
  watch: {
    isActive(newVal) {
      this.isPopupActive = newVal;
      if (this.isPopupActive && this.isNewTaskPrompt) {
        this.reinitComponent();
      }
    },
    isPopupActive(newVal) {
      if (newVal === false) this.$emit('closeTaskPopup', newVal);
    },
    taskEntry(newVal) {
      this.model.isOtherTask = newVal ? newVal.isOtherTask || (newVal && newVal.task === null) : false;
      this.model.otherTaskName = newVal ? newVal.otherTaskName : null;
      this.model.task = newVal ? newVal.task : null;
      this.model.taskId = newVal ? newVal.id : null;
      this.model.isBillable = newVal ? newVal.isBillable : true;
      this.origOtherTaskName = this.model.otherTaskName;
      if (newVal && newVal.task) {
        this.model.taskId = newVal.task.id;
      }
      this.unmodifiedEntry = structuredClone(this.model);
      this.isDuplicateEntry = false;
    },
    'model.taskId'() {
      this.model.task = this.tasks.find(_ => _.id === this.model.taskId);
      this.isValid = this.validatePopup();
    },
    'model.isOtherTask'() {
      this.isValid = this.validatePopup();
    },
    'model.isBillable'() {
      this.isValid = this.validatePopup();
    },
    'model.otherTaskName'() {
      this.isValid = this.validatePopup();
    },
    showAllTasks() {
      this.refreshTasks();
    }
  },
  mounted() {
  },
  computed: {
    tasks() {
      return this.refreshTasks();
    },
    taskPromptTitle() {
      return this.isNewTaskPrompt ? this.$t('Drilling.JobEntries.AddTask') : this.$t('Drilling.JobEntries.EditTask');
    },
    localizedTaskName() {
      return this.$i18n.locale.startsWith('fr') ? "nameFr" : "nameEn";
    }
  },
  methods: {
    submit() {
      return this.$refs.taskPromptObserver.validate().then(() => {
        const clonedModel = structuredClone(this.model);
        if (clonedModel.isOtherTask) {
          clonedModel.taskId = null;
        }
        else {
          clonedModel.task = this.tasks.find(_ => _.id === this.model.taskId);
          clonedModel.task.taskCategory = this.$store.state.drilling.taskCategories.find(c => c.id === this.categoryId);
          clonedModel.isOtherTask = false;
        }
        this.$emit('submit', clonedModel);
      });
    },
    refreshTasks() {
      const arrTasks =  
        this.$store.state.drilling.taskCategoriesPreferred
          .reduce((acc, category) => {
            return acc.concat(category.tasks);
          }, [])
          .filter(_ => this.showAllTasks || _.isPreferred);
      arrTasks.forEach(t => {
        t.fullname = t[this.localizedTaskName] + ' (' + this.$store.state.drilling.taskCategories.find(c => c.id === t.categoryId)[this.localizedTaskName] + ')';
      });
      return arrTasks.sort((a, b) => a.fullname.localeCompare(b.fullname));
    },
    reinitComponent() {
      this.model = this.createModel();
      this.origOtherTaskName = false;
      this.unmodifiedEntry = null;
      this.isDuplicateEntry = false;
    },
    createModel() {
      return {
        isOtherTask: this.jobEntry !== null && this.jobEntry !== undefined ? this.jobEntry.isOtherTask || (this.jobEntry && this.jobEntry.task && this.jobEntry.task.taskId !== null) : false,
        otherTaskName: this.jobEntry !== null && this.jobEntry !== undefined ? this.jobEntry.otherTaskName : null,
        task: this.jobEntry !== null && this.jobEntry !== undefined ? this.jobEntry.task : null,
        isBillable: this.jobEntry !== null && this.jobEntry !== undefined ? this.jobEntry.isBillable : false,
        taskId: this.jobEntry !== null && this.jobEntry !== undefined ? this.jobEntry.taskId : null
      };
    },
    validatePopup() {
      const isValid = this.model.taskId !== null || (this.model.isOtherTask && (this.model.otherTaskName !== null && this.model.otherTaskName !== ''));
      let indexOfunmodifiedEntry = -1;
      if (this.unmodifiedEntry) 
        indexOfunmodifiedEntry = this.existingTasks.findIndex(_ => this.compareTask(_, this.unmodifiedEntry));
      const indexOfModifiedTaskEntry = this.existingTasks.findIndex(_ => this.compareTask(_, this.model));
      this.isDuplicateEntry = indexOfModifiedTaskEntry >= 0 && indexOfModifiedTaskEntry !== indexOfunmodifiedEntry;
      return isValid && !this.isDuplicateEntry;
    },
    compareTask(task1, task2) {
      return task1.isBillable === task2.isBillable && ((task1.task && task2.task && task1.task.id === task2.task.id) || ((task1.isOtherTask || task2.isOtherTask) && task1.isOtherTask === task2.isOtherTask && task1.otherTaskName === task2.otherTaskName));
    }
  },
  emits: ['submit', 'closeTaskPopup']
}